module.exports.pointDistance = function(point1, point2) {
  return Math.sqrt(
    (Math.pow((point1.x - point2.x), 2) + Math.pow((point1.y - point2.y), 2))
  );
};

module.exports.inField = function(point0, point1, point2) {
  return (point0.x >= point1.x && point0.x <= point2.x && point0.y >= point1.y && point0.y <= point2.y);
};

module.exports.directionOfTravel = function(pointStart, pointEnd) {
  let direction = '';

  //positive means down
  const rise = pointEnd.y - pointStart.y;
  //positive means right
  const run = pointEnd.x - pointStart.x;

  if (run < 1 && rise < 1) {
    direction = 'up';
  } else if (run < 1 && rise > 1) {
    direction = 'down';
  } else if (run > 1 && rise < 1) {
    direction = 'up';
  } else if (run > 1 && rise > 1) {
    direction = 'down';
  }

  if (run !== 0 && Math.abs(rise/run) < 0.3) {
    if (run > 1) {
      direction = 'right';
    } else {
      direction = 'left';
    }
  }

  return direction;
};

module.exports.rotation = function(pointStart, pointEnd) {
  let rotation = 0;

  var theta = Math.atan2(pointEnd.x - pointStart.x, pointStart.y - pointEnd.y);

  if (theta < 0.0)
      theta += Math.PI*2;
  
  rotation =  theta;
  //rotation =  theta * 180 / Math.PI;

  //rotation = rotation/360;

  return rotation;
};


// WEBPACK FOOTER //
// ./src/libs/utils.js